<div class="bg-{{widget.bgcolor}} rounded-md p-1" [ngClass]="{'p-1': widget.widget_type !== 'side'}" id="feedbackwidget-{{rnd}}"></div>